/**
 * 设备参数静态说明（旧项目机器人列表弹窗）
 */

export function getDeviceParamsSections(lang) {
  const isZh = !lang || String(lang).toLowerCase().startsWith('zh')
  return isZh ? DEVICE_PARAMS_ZH : DEVICE_PARAMS_EN
}

const DEVICE_PARAMS_ZH = [
  {
    title: '一、外观尺寸参数',
    blocks: [
      {
        items: [
          { label: '设备本体', value: '复合材料球形结构，整体为黑色' },
          { label: '外径尺寸', value: '800mm（±100mm）' },
          { label: '设备质量', value: '≥150kg' }
        ]
      }
    ]
  },
  {
    title: '二、核心功能参数',
    blocks: [
      {
        title: '（一）运动行驶功能',
        items: [
          {
            label: '行驶速度（平直硬化路面）',
            value: '最大速度≥35km/h，巡航速度≥25km/h'
          },
          { label: '爬坡能力', value: '最大爬坡角度≥22°' },
          { label: '越障能力', value: '最大越障高度≥300mm' },
          {
            label: '续航能力',
            value: '最大连续工作时长≥8h，最大运行里程≥100km'
          }
        ]
      },
      {
        title: '（二）智能驾驶功能',
        items: [
          {
            label: '功能说明',
            value:
              '搭载专用算力单元，支持智能自动驾驶、环境感知、运动控制全功能运行'
          }
        ]
      }
    ]
  },
  {
    title: '三、实用性能参数',
    blocks: [
      {
        title: '（一）充电性能',
        items: [
          {
            label: '充电性能',
            value: '快充时长≤3h，配备专用便携式充电器，支持便捷充电'
          }
        ]
      },
      {
        title: '（二）动力配置',
        items: [
          {
            label: '动力配置',
            value:
              '配备1组锂电池组，电量≥2400Wh，内置BMS电池管理系统，保障供电稳定与电池安全'
          }
        ]
      },
      {
        title: '（三）遥控性能',
        items: [
          {
            label: '遥控性能',
            value: '搭配便携式简易遥控器，有效遥控距离可达100m，远程操控便捷'
          }
        ]
      }
    ]
  },
  {
    title: '四、环境适用参数',
    blocks: [
      {
        items: [
          {
            label: '防护等级',
            value: '设备本体防护等级≥IP67，防尘防水性能优异'
          },
          {
            label: '工作温度',
            value: '可适应-25℃～55℃宽温工作环境'
          },
          {
            label: '特殊环境适配',
            value: '支持大暴雨环境下持续稳定工作，户外复杂场景适配性强'
          }
        ]
      }
    ]
  },
  {
    title: '五、核心硬件配置',
    blocks: [
      {
        title: '（一）激光雷达（4台，混合固态式）',
        note: '所有雷达参数均支持提供国家认可第三方检测机构检测报告',
        items: [
          { label: '垂直视场角', value: '-7°～52°' },
          { label: '距离精度', value: '≤±0.1m' },
          { label: '水平角分辨率', value: '≤±0.4°' },
          { label: '适配环境照度', value: '≤7000Lux' },
          { label: '有效探测距离', value: '≥10m@75%反射率' }
        ]
      },
      {
        title: '（二）视觉传感器（4台）',
        items: [
          { label: '成像分辨率', value: '≥1440×1080' },
          { label: '最大帧率', value: '25fps' },
          { label: '有效探测距离', value: '≥5m' }
        ]
      },
      {
        title: '（三）惯性测量单元（1组）',
        items: [
          { label: '偏航角（yaw）', value: '精度≤±1.0°，漂移≤3°/h' },
          { label: '俯仰角（pitch）', value: '精度≤±0.5°' },
          { label: '横滚角（roll）', value: '精度≤±0.5°' }
        ]
      },
      {
        title: '（四）通信模块',
        items: [
          {
            label: '通信模块',
            value: '搭载Wi-Fi模块，支持2.4GHz/5GHz双频段通信，传输稳定'
          }
        ]
      },
      {
        title: '（五）运动控制单元（1组）',
        items: [
          { label: '1000w磁电编码电机', value: '最大扭矩≥3.18Nm' },
          { label: '400w磁电编码电机', value: '最大扭矩≥1.27Nm' }
        ]
      },
      {
        title: '（六）算力单元（1组）',
        items: [
          { label: '处理器', value: '≥4核8线程' },
          { label: '独立显卡', value: '≥6GB' },
          { label: '网络带宽', value: '最大支持≥2.5Ghz' },
          { label: '系统兼容', value: '适配linux操作系统' }
        ]
      }
    ]
  },
  {
    title: '六、挂载附件设备',
    blocks: [
      {
        items: [
          {
            label: '警示设备',
            value: '2个红蓝警示灯，实现作业状态警示'
          },
          {
            label: '声波驱离设备',
            value: '2个声波驱散器，峰值声压142dB@1m'
          },
          {
            label: '操控供电设备',
            value: '1个100m量程便携式遥控器、1个便携式充电器'
          },
          {
            label: '阻截设备',
            value: '2个绊马索&网枪一体化发射器，有效打击距离3m～8m'
          },
          {
            label: '弹体发射设备',
            value: '1个抛投式弹体激发装置，兼容38mm警用催泪弹弹体'
          }
        ]
      }
    ]
  }
]

const DEVICE_PARAMS_EN = [
  {
    title: '1. Appearance & Dimensions',
    blocks: [
      {
        items: [
          {
            label: 'Body',
            value: 'Composite spherical structure, overall black'
          },
          { label: 'Outer diameter', value: '800mm (±100mm)' },
          { label: 'Mass', value: '≥150kg' }
        ]
      }
    ]
  },
  {
    title: '2. Core Functions',
    blocks: [
      {
        title: '(1) Mobility',
        items: [
          {
            label: 'Speed (flat paved road)',
            value: 'Max ≥35km/h, cruise ≥25km/h'
          },
          { label: 'Climbing', value: 'Max slope ≥22°' },
          { label: 'Obstacle crossing', value: 'Max height ≥300mm' },
          {
            label: 'Endurance',
            value: 'Continuous work ≥8h, range ≥100km'
          }
        ]
      },
      {
        title: '(2) Intelligent driving',
        items: [
          {
            label: 'Capability',
            value:
              'Dedicated compute unit enabling autonomous driving, perception, and motion control'
          }
        ]
      }
    ]
  },
  {
    title: '3. Practical Performance',
    blocks: [
      {
        title: '(1) Charging',
        items: [
          {
            label: 'Charging',
            value: 'Fast charge ≤3h with dedicated portable charger'
          }
        ]
      },
      {
        title: '(2) Power',
        items: [
          {
            label: 'Power',
            value:
              '1× lithium battery pack ≥2400Wh with built-in BMS for stable and safe power'
          }
        ]
      },
      {
        title: '(3) Remote control',
        items: [
          {
            label: 'Remote control',
            value: 'Portable remote with effective range up to 100m'
          }
        ]
      }
    ]
  },
  {
    title: '4. Environmental Suitability',
    blocks: [
      {
        items: [
          {
            label: 'Ingress protection',
            value: 'Body protection ≥IP67, excellent dust/water resistance'
          },
          {
            label: 'Operating temperature',
            value: '-25℃ to 55℃ wide-temperature operation'
          },
          {
            label: 'Harsh environments',
            value: 'Stable operation in heavy rain and complex outdoor scenes'
          }
        ]
      }
    ]
  },
  {
    title: '5. Core Hardware',
    blocks: [
      {
        title: '(1) LiDAR (4× hybrid solid-state)',
        note: 'All LiDAR specs support third-party accredited test reports',
        items: [
          { label: 'Vertical FOV', value: '-7° to 52°' },
          { label: 'Range accuracy', value: '≤±0.1m' },
          { label: 'Horizontal angular resolution', value: '≤±0.4°' },
          { label: 'Ambient illuminance', value: '≤7000Lux' },
          { label: 'Effective range', value: '≥10m @ 75% reflectivity' }
        ]
      },
      {
        title: '(2) Vision sensors (4×)',
        items: [
          { label: 'Resolution', value: '≥1440×1080' },
          { label: 'Max frame rate', value: '25fps' },
          { label: 'Effective range', value: '≥5m' }
        ]
      },
      {
        title: '(3) IMU (1×)',
        items: [
          { label: 'Yaw', value: 'Accuracy ≤±1.0°, drift ≤3°/h' },
          { label: 'Pitch', value: 'Accuracy ≤±0.5°' },
          { label: 'Roll', value: 'Accuracy ≤±0.5°' }
        ]
      },
      {
        title: '(4) Communication',
        items: [
          {
            label: 'Communication',
            value: 'Wi-Fi module with 2.4GHz/5GHz dual-band support'
          }
        ]
      },
      {
        title: '(5) Motion control unit (1×)',
        items: [
          { label: '1000W mag-encoded motor', value: 'Max torque ≥3.18Nm' },
          { label: '400W mag-encoded motor', value: 'Max torque ≥1.27Nm' }
        ]
      },
      {
        title: '(6) Compute unit (1×)',
        items: [
          { label: 'CPU', value: '≥4 cores / 8 threads' },
          { label: 'Dedicated GPU', value: '≥6GB' },
          { label: 'Network bandwidth', value: 'Up to ≥2.5GHz' },
          { label: 'OS compatibility', value: 'Linux compatible' }
        ]
      }
    ]
  },
  {
    title: '6. Mounted Accessories',
    blocks: [
      {
        items: [
          {
            label: 'Warning lights',
            value: '2× red-blue warning lights for operation status'
          },
          {
            label: 'Acoustic deterrence',
            value: '2× acoustic dispersers, peak SPL 142dB@1m'
          },
          {
            label: 'Control & power',
            value: '1× 100m-range portable remote, 1× portable charger'
          },
          {
            label: 'Interdiction',
            value:
              '2× tripwire & net-gun integrated launchers, effective range 3m–8m'
          },
          {
            label: 'Projectile launcher',
            value:
              '1× throw-type projectile activator, compatible with 38mm police tear-gas rounds'
          }
        ]
      }
    ]
  }
]
